export default {"src":"/_next/static/media/seasonal-interest.f6120162.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};